import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

import {
  appendNotification,
  destroyNotificationRequest,
  destroyNotificationSuccess,
} from './notification.actions';
import {
  adapter,
  notificationSelectors,
  type NotificationsState,
} from './notification.interfaces';

const selectFeature =
  createFeatureSelector<NotificationsState>('notifications');

export const selectFeatureCount = createSelector(
  selectFeature,
  state => state.counter,
);
const selectNotificationEntities = createSelector(
  selectFeature,
  notificationSelectors.selectEntities,
);
export function selectNotificationById(number: number) {
  return createSelector(
    selectNotificationEntities,
    notifications => notifications[number],
  );
}

const initialState: NotificationsState = adapter.getInitialState({
  counter: 0,
});

export const reducer = createReducer(
  initialState,
  on(appendNotification, (state, action) => {
    return adapter.addOne(action, {
      ...state,
      counter: state.counter + 1,
    });
  }),
  on(destroyNotificationRequest, (state, action) => {
    return adapter.updateOne(action, state);
  }),
  on(destroyNotificationSuccess, (state, action) => {
    return adapter.removeOne(action.id, state);
  }),
);
